module.exports = __webpack_public_path__ + "revenue.png?9ef626ffe93a262b153b67857e27a23b";